module.exports = __webpack_public_path__ + "img/app_main.0b746ec8.png";